import { FileData } from "@/types";

export const files: FileData[] = [
    {
        id: "1",
        name: "file.pdf",
        created_at: "20/01/2025 16:00:00",
        selected: false,
        project_id: "1",
        path: "1",
        type: "gis",
        size: 100,
        url: "https://storage.googleapis.com/weitz-dev-public-bucket/6743188bb24b2583bb8ddc85_675158b55bcba0c81b49ecc7_67a08cf83fb5ee36bbe682ac_table.pdf"
    },
    {
        id: "2",
        name: "file.txt",
        created_at: "20/01/2025 16:00:00",
        selected: false,
        project_id: "1",
        path: "1",
        type: "outlinePlans",
        size: 100,
        url: "1"
    }
];
